import { LitElement, css, html } from 'lit';

import { StateController } from '../helpers/state/state-management/state-controller';
import { customElement } from 'lit/decorators';
import topicData from '../helpers/state/topic-data';

@customElement('challenge-uncheck-confirm-modal')
export class ChallengeUncheckConfirmModal extends LitElement {
    static amplitude_callsite: string = 'Challenge Uncheck Confirm Modal';

    private readonly bindTopicState = new StateController(this, topicData);


    private handleConfirmUncheckChallenge() {
        this.dispatchEvent(
            new CustomEvent('on-confirm')
        );
    }

    private handleCancelUncheckChallenge() {
        this.dispatchEvent(
            new CustomEvent('on-cancel')
        );
    }

    render() {
        return html`
            <div class="modalContent">
                <div class="modal__content">
                    <p class="description">
                        Are you sure you want to remove this check in? It may impact your status?
                    </p>
                    <div class="actions-wrapper">
                        <mwc-button
                            raised
                            class="action-button  aqua-blue"
                            @click="${this.handleConfirmUncheckChallenge}"
                        >
                            Remove this check in
                        </mwc-button>
                        <mwc-button
                            raised
                            class="action-button"
                            @click="${this.handleCancelUncheckChallenge}"
                        >
                            Cancel
                        </mwc-button>
                    </div>
                </div>
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                --modal-width: 550px;
            }

            .modalContent {
                position: relative;
                height: auto;
                overflow-y: auto;
                box-sizing: border-box;
            }

            .modal__header {
                width: 100%;
                text-align: center;
                padding: 0px 20px 5px;
                border-bottom: solid 1px #efecf3;
                color: var(--theme-input-color);
                font-size: 18px;
                font-weight: 700;
                line-height: 1.3em;
                box-sizing: border-box;
            }

            .modal__content {
                padding: 5px 0;
                width: 100%;
                box-sizing: border-box;
            }

            .actions-wrapper {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
                flex-wrap: wrap;
            }

            .action-button {
                font-size: 16px;
                border-radius: 8px;
                margin: 10px 0;
                color: var(--theme-white-color);
                --mdc-typography-button-text-transform: capitalize;
            }

            .aqua-blue {
                --btn-background-color: var(--main-secondary-color);
                --mdc-theme-primary: var(--main-secondary-color);
            }

            p {
                text-align: center;
                margin: 5px 0 15px;
                color: var(--theme-input-color);
            }

            @media only screen and (max-width: 550px) {
                .modalContent {
                    width: 100%;
                    min-height: 100%;
                    max-height: 100%;
                }
            }
        `;
    }
}
